var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"position":"fixed"}},[_c('AskGoOn',{attrs:{"showWarning":"","show":_vm.visible,"cancelBtnShow":false,"title":"当前登录用户已变更","showText":"您的浏览器刚才登录了其他用户，当前用户已被更换，点击确定后将会以新的用户身份刷新当前页面，请留意。","okText":"刷新"},on:{"ok":function($event){return _vm.reload()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }